import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useAppSelector from './useAppSelector';
import { selectBridgeSlice } from '../redux/slices/bridgeSlice';

interface ServiceStatusRes {
  code: number;
  statusCode: string;
  message: string;
  data: {
    isBlocking: boolean;
  };
}
const useServiceOnOff = () => {
  const [isServiceOff, setIsServiceOff] = useState(false);
  const { pathname } = useLocation();
  const { convertNow } = useAppSelector(selectBridgeSlice);

  const serviceStatus = useCallback(async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_KSTADIUM_BACKEND_URL}/kstadium/api/v2/external/support/service-on-off/bridge`,
        {
          method: `GET`,
          headers: {
            'Content-Type': `application/json`,
          },
        },
      );
      const { data }: ServiceStatusRes = await res.json();
      setIsServiceOff(data.isBlocking);
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    serviceStatus();
  }, [serviceStatus, pathname, convertNow]);

  return isServiceOff;
};

export default useServiceOnOff;
